import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { modals } from '@/mixins/modal';
import ReadSubmission from './read-submission';

export default Vue.component('site-forms', {
  template: require('./template.html'),
  name: 'site-forms',
  mixins: [modals],
  components: {
    ReadSubmission,
  },
  computed: {
    ...mapGetters(['currentSite']),
    filteredList() {
      const allTypes = this.currentSite.pages.concat(
        this.currentSite.drafts,
        this.currentSite.templates,
      );
      const list = this.currentSite.formSubmissions.map((msg) => {
        const exists = allTypes.find(p => p._id === msg.pageId);
        let page = 'Deleted Page';
        let type = 'Deleted Type';
        if (exists) {
          page = exists.name;
          type = exists.type;
        }
        return {
          _id: msg._id,
          submittedOn: new Date(msg.submittedOn),
          page,
          type,
          msg,
        };
      });
      const sortOn = this.sortKey || this.cols[0];
      const updated = _.chain(list)
        .thru((t) => {
          if (this.filterKey) {
            return _.reduce(
              t,
              (acc, row) => {
                const e = [];
                _.filter(row, () => {
                  _.forEach(this.cols, (c) => {
                    // clean up the values so that the
                    // searchable items are like how
                    // the template is written
                    const col = this.cleanItem(row[c], c, row);
                    e.push(col);
                  });
                });
                if (
                  _.filter(e, v =>
                    _(v)
                      .toLower()
                      .includes(this.filterKey.toLowerCase()),
                  ).length
                ) {
                  acc.push(row);
                }
                return acc;
              },
              [],
            );
          }
          return t;
        })
        .sort((a, b) => {
          // We'll sort accending by default and we'll also ignore case
          // since that may confuse non-technical users
          const ascDesc = this.sortMap[sortOn];
          a = _.isString(a[sortOn]) ? _.toLower(a[sortOn]) : a[sortOn]; // eslint-disable-line
          b = _.isString(b[sortOn]) ? _.toLower(b[sortOn]) : b[sortOn]; // eslint-disable-line

          return (a === b ? 0 : a < b ? 1 : -1) * ascDesc; // eslint-disable-line
        })
        .value();
      return updated;
    },
  },
  data() {
    const cols = ['page', 'submittedOn'];
    const sortMap = _.zipObject(cols, _.fill(Array(cols.length), 1));
    return {
      cols,
      sortMap,
      sortKey: 'submittedOn',
      filterKey: '',
      paginate: ['submissionList'],
      loading: false,
      readModal: false,
      activeSubmission: null,
      error: false,
    };
  },
  mounted() {
    // used for the modal mixin
    this.cls = '.adminUi-modalOverlay';
  },
  methods: {
    async fetchFormSubmissions() {
      this.loading = true;
      this.error = false;
      try {
        const response = await this._SEND([{
          name: 'fetchFormSubmissions',
          payload: {
            site: this.currentSite._id,
          },
        }]);
        this.$log.debug('Successfully fetched form submission: ', response);

        // add to state
        const fn = () => {
          this.currentSite.formSubmissions = response.list;
        };
        this.$store.dispatch('runStateFn', { fn });
      } catch (e) {
        this.$log.error(e.message || e);
        this.error = e.message || e;
        await this._reportError({
          error: e,
          fn: 'fetchFormSubmissions',
        });
      } finally {
        this.loading = false;
        this._trackEvent({
          type: 'fetch_form_submissions',
          meta: {
            site_name: this.currentSite.alias,
            site_type: this.currentSite.type,
            site_tier: this.currentSite.tier,
            site_forms: this.currentSite.forms.length,
          },
        });
      }
    },
    toggleModal(item, c) {
      this.readModal = !this.readModal;
      const content = !c ? this.$refs.readModal : this.$refs.readModal.$el;
      if (this.readModal) {
        this.activeSubmission = item;
        this.modelMoveOut(content);
      } else {
        this.modalMoveIn(content);
      }
    },
    cleanItem(item, col, obj) {
      let i = item || '--';
      if (col === 'submittedOn' && i !== '--') {
        i = new Date(i);
        i = this._zoneFormat({
          date: i.toISOString(),
          format: 'MM-DD-YYYY hh:mm A z',
          zone: this.currentSite.timezone,
        });
      }
      if (col === 'page') {
        i = `${item} - (${obj.type})`;
      }
      return i;
    },
    highlight(ctx, query, col, item) {
      const c = this.cleanItem(ctx, col, item);
      return c.replace(
        new RegExp(query, 'ig'),
        match => `<span class='editorUi-searchHighlight'>${match}</span>`,
      );
    },
    setSortKey(k) {
      this.sortKey = k;
      // Invert the value for ascDesc
      this.sortMap[k] = this.sortMap[k] * -1;
    },
    title(name) {
      return _.startCase(name);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/websites/edit-site/forms/index.js